import type { SVGProps } from 'react';

interface IconProps extends SVGProps<SVGSVGElement> {
  size?: number | string;
}

export function CrownIcon({ size = 24, className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-label="crown"
      {...props}
    >
      <title>Crown</title>
      <path d="M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L20.266 6.5a.5.5 0 0 1 .734.545l-2.725 13.095a1 1 0 0 1-.975.86H6.7a1 1 0 0 1-.975-.86L3 7.045a.5.5 0 0 1 .734-.545l3.36 2.664a1 1 0 0 0 1.516-.294z" />
    </svg>
  );
}
